import { defineComponent, computed, ref, watch, createBlock, openBlock, unref, withCtx, createElementVNode, createElementBlock, createCommentVNode, createVNode, toDisplayString, withKeys, createTextVNode } from "vue";
import { useI18n } from "vue-i18n";
import UButton from "@nuxt/ui/components/Button.vue";
import UInput from "@nuxt/ui/components/Input.vue";
import UFormField from "@nuxt/ui/components/FormField.vue";
import CodSheet from "./index28.js";
import { isValidEmail } from "./index40.js";
const _hoisted_1 = { class: "flex flex-col gap-4 px-4 pb-4" };
const _hoisted_2 = {
  key: 0,
  class: "text-body text-muted"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PdfEmailSheet",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    /** One line naming the document, e.g. "Periodični izveštaj · 01.10.2026–07.10.2026". */
    documentLine: {
      type: String,
      default: ""
    },
    /** The address the field opens with. */
    defaultRecipient: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    /** An example address in the field — whose address the kind expects (an accountant's, a customer's). */
    placeholder: {
      type: String,
      default: ""
    },
    /** Sends the document to the address; resolves with the server PDF result. */
    send: {
      type: Function,
      required: true
    }
  },
  emits: ["update:modelValue", "sent", "failed"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const open = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value)
    });
    const recipient = ref("");
    const openedWith = ref("");
    const sending = ref(false);
    watch(() => props.modelValue, (isOpen) => {
      if (!isOpen) return;
      openedWith.value = props.defaultRecipient;
      recipient.value = props.defaultRecipient;
      sending.value = false;
    }, { immediate: true });
    const touched = computed(() => recipient.value !== openedWith.value);
    const valid = computed(() => isValidEmail(recipient.value));
    const canSend = computed(() => valid.value && !sending.value);
    const recipientError = computed(() => touched.value && recipient.value.trim() && !valid.value ? t("validation.email") : void 0);
    async function submit() {
      if (!canSend.value) return;
      sending.value = true;
      const to = recipient.value.trim();
      try {
        const result = await props.send(to);
        if (!result.success) {
          emit("failed", result.error || "general");
          return;
        }
        emit("sent", to);
        open.value = false;
      } catch (error) {
        console.error("PDF email: send failed", error);
        emit("failed", "general");
      } finally {
        sending.value = false;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(CodSheet, {
        modelValue: open.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => open.value = $event),
        "show-header": "",
        title: __props.title || unref(t)("pdf.email_title"),
        width: "480px",
        guard: sending.value
      }, {
        footer: withCtx(() => [
          createVNode(UButton, {
            color: "neutral",
            variant: "outline",
            size: "lg",
            disabled: sending.value,
            onClick: _cache[1] || (_cache[1] = ($event) => open.value = false)
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("general.cancel")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          createVNode(UButton, {
            color: "primary",
            variant: "solid",
            size: "lg",
            icon: "i-lucide-mail",
            loading: sending.value,
            disabled: !canSend.value,
            onClick: submit
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("pdf.send")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            __props.documentLine ? (openBlock(), createElementBlock("p", _hoisted_2, toDisplayString(__props.documentLine), 1)) : createCommentVNode("", true),
            createVNode(UFormField, {
              label: unref(t)("pdf.recipient"),
              error: recipientError.value
            }, {
              default: withCtx(() => [
                createVNode(UInput, {
                  modelValue: recipient.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => recipient.value = $event),
                  type: "email",
                  inputmode: "email",
                  autocomplete: "email",
                  class: "w-full",
                  placeholder: __props.placeholder || unref(t)("pdf.recipient_placeholder"),
                  disabled: sending.value,
                  onKeyup: withKeys(submit, ["enter"])
                }, null, 8, ["modelValue", "placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label", "error"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "guard"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index39.js.map
